import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select from "react-select";
interface Option {
  label: string;
  value: string;
}
interface DropdownMultiOptionProps {
  name?: string,
  initialValue?: Option | Option[] | undefined | null;
  dataList?: Option[];
  onChangeSelect?: (params: Option | Option[]) => void;
  placeholder?: string;
  disabled?: boolean,
  className?: string,
  classNamePrefix?: string,
  isHasOptionAll?: boolean,
  optionAll?: undefined | Option,
  labelTop?: string,
  isMulti?: boolean,
  cacheOptions?: boolean,
  isShowIcon?: boolean,
  icons?: any,
  style?: any
}

const DropdownMultiOption = ({
  name = '',
  initialValue,
  onChangeSelect,
  dataList = [],
  placeholder,
  disabled = false,
  className = '',
  classNamePrefix = '',
  isHasOptionAll = false,
  optionAll,
  labelTop = '',
  isMulti = true,
  cacheOptions = false,
  isShowIcon = false,
  icons = {},
  style = {}
}: DropdownMultiOptionProps) => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<Option[]>([]);

  const setOnChangeOption = (item: any) => {
    onChangeSelect && onChangeSelect(item);
  };

  useEffect(() => {
    const resultOptions = dataList?.map((item) => ({ label: item?.label, value: String(item?.value || '') })) || [] as Option[];
    const result: any = isHasOptionAll ? [optionAll].concat(resultOptions) : resultOptions;
    setOptions((_prev: any) => result);

    if (initialValue) {
      setOnChangeOption(initialValue);
    } else {
      setOnChangeOption(isHasOptionAll ? result[0] : null);
    }
  }, [JSON.stringify(dataList), JSON.stringify(initialValue)]);

  return (
    <div className="position-relative" style={style}>
      <Select
        options={options}
        value={initialValue}
        name={name}
        isDisabled={disabled}
        cacheOptions={cacheOptions}
        onChange={(e: any) => setOnChangeOption(e)}
        placeholder={<div>{placeholder || ''}</div>}
        loadingMessage={() => (<div>{t('Loading')}...</div>)}
        noOptionsMessage={() => (<div>{t('No Options')}</div>)}
        className={className}
        classNamePrefix={classNamePrefix}
        isClearable={false}
        isMulti={isMulti}
        formatOptionLabel={isShowIcon ? (option: any) => (
          <div className="d-flex align-items-center justify-content-start">
            {icons?.[option?.value] && (
              <img src={icons?.[option?.value]} alt={option?.label} className="object-fit-cover" style={{ width: "15px", height: '15px', borderRadius: '3px' }} />
            )}
            <div className="ms-2">
              {option?.label}
            </div>
          </div>
        ) : null}
      />
      {labelTop && (initialValue) && (<label style={{
        position: 'absolute',
        left: '5px',
        top: '0px',
        marginBottom: '0px',
        transform: 'translateY(-50%)',
        padding: `0px 5px`,
        color: '#c2c2c2',
        fontSize: '12px',
        fontWeight: '400',
        borderRadius: '3px',
        backgroundColor: disabled ? 'hsl(0, 0%, 95%)' : 'var(--vz-secondary-bg)',
      }}>
        {labelTop}
      </label>)}
    </div>
  );
};

export default DropdownMultiOption;
